import React, { Fragment } from 'react';
import { Button, Divider, Form, Grid, Icon, Label, Loader, Popup, Segment, Table, Radio } from 'semantic-ui-react';
import axios from 'axios';
import Modal from 'react-responsive-modal';
import { toast, ToastContainer } from 'react-toastify';
import { fetchAcademicYears, fetchStudyType } from '../../Lookups/util';
import SimpleTwoColumnTableRow from '../../StudentPersonalInfo/SimpleTwoColumnTableRow';

export const fetchStudentSemesters = (studentStudyProgramId) => axios.get(localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || localStorage.getItem('activeRole') === 'Support'
    ? `students/${studentStudyProgramId}/semesters/overview-for-admin/` : `students/${studentStudyProgramId}/semesters/overview/`);
export const fetchCurrentSemestersDropdown = () => axios.get('semester/academic-year/current/');
export const fetchStudentStatuses = () => axios.get('student-statuses/to-enroll/');
export const fetchStudentStatusesLookup = () => axios.get('student-statuses');
export const fetchStudentSemesterInfo = (studentStudyProgramId, typeOfEnrollment, semester) =>
    axios.post(`semester-enrollment/information/${studentStudyProgramId}/${typeOfEnrollment === 1}/${typeOfEnrollment === 2}/${typeOfEnrollment === 3}`, { ...semester });
export const fetchCourses = (studentStudyProgramId) => axios.get(`course/basic/not-passed/${studentStudyProgramId}/`);

const typeOfEnrollmentOptions = [
    // {
    //     key: 1,
    //     value: 1,
    //     text: 'bezuslovni upis'
    // },
    // {
    //     key: 2,
    //     value: 2,
    //     text: 'prenos ECTS-a unutar ciklusa'
    // },
    {
        key: 3,
        value: 3,
        text: 'zanemari uslovne predmete'
    },
];
export default class NextSemesterEnroll extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studentStatusesLookup: [],
            studentSemesters: [],
            currentSemestersDropdown: [],
            currentSemesters: [],
            currentSemester: '',
            typeOfEnrollment: null,

            studyTypes: [],
            studyType: '',
            studentStatuses: [],
            studentStatusesOpt: [],
            studentStatus: '',
            semesterToEnroll: '',
            requiredEcts: '',
            acquiredEcts: '',
            courses: [],
            coursesForSemester: '',
            currentSemesterId: -1,
            studentStatusEdit: null,
            studyTypeEdit: null,

            semesterNumOptions: [],

            loading: true,
            open: false,
            locked: false,
            graduated: false,
            gradEnroll: false,
            showCourses: false,
            loadingCourses: true,


            semesters: [],
            semester: null,
            academicYears: [],
            academicYearsAdmin: [],
            academicYearId: null,
            studyProgramSemesters: [],
            studyProgramSemester: null,
            currentEnrollment: false

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.enrollStudent = this.enrollStudent.bind(this);
        this.studentGradEnroll = this.studentGradEnroll.bind(this);
        this.getCoursesForSemester = this.getCoursesForSemester.bind(this);
        this.processNextEnrollment = this.processNextEnrollment.bind(this);

        this.deleteSemester = this.deleteSemester.bind(this);
        this.deleteCourse = this.deleteCourse.bind(this);
        this.deleteGradYear = this.deleteGradYear.bind(this);

        this.editStudentStatusAndType = this.editStudentStatusAndType.bind(this);
        this.closeAndResetForm = this.closeAndResetForm.bind(this);
        this.fetchSemesters = this.fetchSemesters.bind(this);

        this.isGradStudent = this.isGradStudent.bind(this);
        this.enroll = this.enroll.bind(this);
    }


    isGradStudent() {
        const { studentStudyProgramId } = this.props;
        axios.get(`students/grad-year-enrollment-information/${studentStudyProgramId}`)
            .then(res => {
                this.setState({
                    gradAcademicYearStudyTypeId: res.data.gradAcademicYearStudyTypeId,
                    gradAcademicYearStudentStatusId: res.data.gradAcademicYearStudentStatusId,
                    gradStudentAcademicYearId: res.data.gradStudentAcademicYearId
                }, () => this.fetchSemesters());
            })
            .catch(err => {
                // this.fetchSemesters();
                this.isGradStudent();
                console.log('Is grad student method failed!');
            });
    }

    componentWillMount() {
        this.isGradStudent();
    }

    componentDidMount() {
        axios.get('/study-program-semesters')
            .then(res => {
                let studyProgramSemesters = res.data.map(el => ({
                    ...el, key: el.id, value: el, text: el.name
                }));
                this.setState({
                    studyProgramSemesters
                });
            });

        const { studentStudyProgramId } = this.props;
        axios.get('/study-program-semesters')
            .then(res => {
                this.setState({
                    semesterNumOptions: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    }))
                });
            });


        // fetchStudentSemesterInfo(studentStudyProgramId), fetchCourses(studentStudyProgramId),
        // infoRes, coursesRes,
        axios.all([fetchStudyType(), fetchStudentStatuses(), fetchStudentStatusesLookup(), fetchCurrentSemestersDropdown(), fetchAcademicYears(),
            fetchStudentSemesters(studentStudyProgramId), fetchAcademicYears()])
            .then(axios.spread((typesRes, statusesRes, statusesLookupRes, currentSemRes, yearsRes, academicYearsRes) => {
                const studyTypes = typesRes.data.map(el => ({
                    ...el, key: el.id, value: el, text: el.displayName
                }));

                const studentStatusesOpt = statusesRes.data.map(el => ({
                    key: el.id, value: el, text: el.name
                }));
                let studentStatuses = statusesRes.data.map(el => ({
                    ...el, key: el.id, value: el, text: el.name
                }));

                if (localStorage.getItem('activeRole').substr(0, 41) !== 'Studentska: Akademija scenskih umjetnosti') {
                    studentStatuses = studentStatuses.filter(el => el._key !== 'gap_year');
                }
                this.setState({
                    studentStatuses
                });

                const studentStatusesLookup = statusesLookupRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));


                this.setState({
                    studentStatuses,
                    studyTypes,
                    studentStatusesOpt,
                    studentStatusesLookup,
                    academicYears: academicYearsRes.data,

                    currentSemestersDropdown: currentSemRes.data.filter(e => e.name.name !== 'ostalo').map(el => ({
                        value: el.id, key: el.id, text: el.name.name + ' ' + el.academicYear.name
                    })),

                    currentSemesters: currentSemRes.data,
                    studentStatus: statusesRes.data[0],
                    loading: false,

                    academicYearsAdmin: yearsRes.data.map(el => ({
                        key: el.id, value: el.id, text: el.name
                    })).reverse(),

                    // semesterToEnroll: infoRes.data.semesterToEnroll !== null ? infoRes.data.semesterToEnroll.name : '',
                    // requiredEcts: infoRes.data.requiredEcts !== null ? infoRes.data.requiredEcts : '',
                    // acquiredEcts: infoRes.data.acquiredEcts !== null ? infoRes.data.acquiredEcts : '',
                    // courses: coursesRes.data ? coursesRes.data : [],
                    // locked: infoRes.data.locked,
                    // graduated: infoRes.data.graduated
                });
            }))
            .catch(err => {
                console.log('Failed to fetch study types, student statuses or semester info...');
            });
    }

    fetchSemesters() {
        const { studentStudyProgramId } = this.props;
        fetchStudentSemesters(studentStudyProgramId)
            .then(res => {
                let studentSemesters = [];
                if (this.state.gradStudentAcademicYearId || res.data.filter(e => e.semester.name.name === 'ostalo').length !== 0) {
                    if (res.data.filter(e => e.semester.name.name === 'ostalo').length !== 0) {
                        this.setState({ gradStudentAcademicYearId: this.state.gradStudentAcademicYearId || res.data.filter(e => e.semester.name.name === 'ostalo')[0].semester.academicYear.id });
                    }
                    studentSemesters = [{

                        semester: {
                            academicYear: {
                                id: res.data.filter(e => e.semester.name.name === 'ostalo').length !== 0 ?
                                    res.data.filter(e => e.semester.name.name === 'ostalo')[0].semester.academicYear.id
                                    : this.state.gradStudentAcademicYearId,
                                name: res.data.filter(e => e.semester.name.name === 'ostalo').length !== 0 ?
                                    res.data.filter(e => e.semester.name.name === 'ostalo')[0].semester.academicYear.name : localStorage.getItem('apsolvent')
                            },
                            name: res.data.filter(e => e.semester.name.name === 'ostalo').length !== 0 && res.data.filter(e => e.semester.name.name === 'ostalo')[0].studentStatus.name === 'ispisan' ? { name: 'Ispisan' } : { name: 'Apsolventski staž' }
                        },
                        studyProgramSemester: {
                            name: ''
                        },
                        studyType: { id: this.state.gradAcademicYearStudyTypeId },
                        studentStatus: res.data.filter(e => e.semester.name.name === 'ostalo').length !== 0 && res.data.filter(e => e.semester.name.name === 'ostalo')[0].studentStatus.name === 'ispisan' ? res.data.filter(e => e.semester.name.name === 'ostalo')[0].studentStatus : { id: this.state.gradAcademicYearStudentStatusId },
                    }];
                }
                this.setState({
                    studentSemesters: [...studentSemesters, ...res.data],
                });
            })
            .catch(err => {
                toast('Došlo je do greške prilikom dobavljanja semestara!');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });

        if (name === 'academicYearId') {
            axios.get(`semester/by-academic-year/${value}`)
                .then(res => {
                    this.setState({
                        semesters: res.data.filter(e => e.name.name !== 'ostalo').map(el => ({
                            ...el, key: el.id, value: el, text: el.name.name
                        }))
                    });
                });
        }
    }

    deleteGradYear(el) {
        axios.get(`students/study-program/${this.props.studentStudyProgramId}/`)
            .then(res => {
                let obj = {
                    id: this.props.studentStudyProgramId,
                    optLock: res.data.optLock,
                    gradStudentAcademicYearId: el.semester.academicYear.id
                };
                axios.put('students/delete-grad-year-enrollment', { ...obj })
                    .then(ress => {
                        toast('Uspješno ste ispisali studenta iz apsolventskog staža.');
                        this.isGradStudent();
                    })
                    .catch(err => {
                        if (err.response.data === 'Student is enrolled in courses in grad academic year and thus grad year enrollment cannot be deleted!') {
                            toast('Student je upisan na neke predmete. Potrebno je ispisati studenta iz predmeta prije ispisa iz apsolventskog staža.');
                        } else {
                            toast('Došlo je do greške! Student nije ispisan iz apsolventskog staža.');
                        }
                    });
            }).catch(err => {
                console.log('Failed to fetch student study program optLock');
            });
    }

    deleteSemester(el) {
        axios.delete(`semester-enrollment/delete/${el.studentStudyProgramSemesterId}`)
            .then(res => {
                toast('Uspješno ste ispisali studenta iz semestra.');
                this.fetchSemesters();
            })
            .catch(err => {
                if (err.response.data === 'Student is enrolled in courses for passed semester and thus cannot be deleted!') {
                    toast('Student je upisan na neke predmete. Potrebno je ispisati studenta iz predmeta prije brisanja semestra.');
                } else {
                    toast('Došlo je do greške! Student nije ispisan iz semestra.');
                }
            });
    }

    deleteCourse(el) {
        axios.delete(`students/delete-student-course-implementation/${el.studentCourseImplementationId}`)
            .then(res => {
                toast('Uspješno ste ispisali studenta iz predmeta.');
                { this.state.apsolvent ? this.getCoursesForSemester(this.state.currentSemesterId, this.state.currentStudentStudyProgramId, 'apsolvent')
                    : this.getCoursesForSemester(this.state.currentSemesterId, this.state.currentStudentStudyProgramId); }
            })
            .catch(err => {
                if (err.response.data === 'Student registered exams for this course and thus cannot be deleted!') {
                    toast('Nije moguće ispisati studenta. Student je prijavio ispite iz ovog predmeta.');
                } else if (err.response.data === 'Student questionnaire links cannot be deleted if accessed is true!') {
                    toast('Nije moguće ispisati studenta. Student je ocijenio anketu za ovaj predmet.');
                } else if (err.response.data === 'More than one sspcs found for passed sci!') {
                    toast('Nije moguće ispisati studenta. More than one sspcs found for passed sci!');
                } else {
                    toast('Došlo je do greške! Student nije ispisan iz predmeta.');
                }
            });
    }

    editStudentStatusAndType(el, aps = false) {
        if (aps) {
            axios.get(`students/study-program/${this.props.studentStudyProgramId}/`)
                .then(res => {
                    let obj = {
                        id: this.props.studentStudyProgramId,
                        optLock: res.data.optLock,
                        gradAcademicYearStudyTypeId: this.state.studyTypeEdit ? this.state.studyTypeEdit.id : null,
                        gradAcademicYearStudentStatusId: this.state.studentStatusEdit ? this.state.studentStatusEdit.id : null,
                        gradStudentAcademicYearId: el.semester.academicYear.id
                    };
                    axios.put('students/enroll/grad-year/edit', { ...obj })
                        .then(res => {
                            toast('Uspješno ste izmijenili podatke.');
                            this.setState({ studyTypeEdit: null, studentStatusEdit: null });
                            this.isGradStudent();
                        })
                        .catch(err => {
                            toast('Došlo je do greške! Podaci nisu izmijenjeni.');
                        });
                }).catch(err => {
                    console.log('Failed to fetch student study program optLock');
                });
        } else {
            let obj = {
                studentStudyProgramId: el.studentStudyProgramId,
                optLock: el.optLock,
                studentStudyProgramSemesterId: el.studentStudyProgramSemesterId,
                studentStatus: this.state.studentStatusEdit ? { id: this.state.studentStatusEdit.id, optLock: this.state.studentStatusEdit.optLock } : null,
                studyType: this.state.studyTypeEdit ? { id: this.state.studyTypeEdit.id, optLock: this.state.studyTypeEdit.optLock } : null,
            };
            axios.put('semester-enrollment/edit', { ...obj })
                .then(res => {
                    toast('Uspješno ste izmijenili podatke.');
                    this.setState({ studyTypeEdit: null, studentStatusEdit: null });
                    this.fetchSemesters();
                })
                .catch(err => {
                    toast('Došlo je do greške! Podaci nisu izmijenjeni.');
                });
        }
    }

    enrollStudent() {
        this.setState({ enrollStep2Loader: true });
        let semester = this.state.currentSemesters.find(el => el.id === this.state.currentSemester);
        let obj = {
            studentStudyProgramId: this.props.studentStudyProgramId,
            studyType: { id: this.state.studyType.id },
            studentStatus: { id: this.state.studentStatus.id, _key: this.state.studentStatus._key },
            semester,
            unconditionalEnrollment: this.state.typeOfEnrollment === 1,
            ectsTransferWithinStudyCycle: this.state.typeOfEnrollment === 2,
            ignorePrerequisiteCourses: this.state.typeOfEnrollment === 3
        };
        let organizationalUnitId = localStorage.getItem('orgUnit');
        axios.post(localStorage.getItem('activeRole') === 'Administrator' ? `semester-enrollment/next-semester/${organizationalUnitId}` : 'semester-enrollment/next-semester/', { ...obj })
            .then(res => {
                toast('Student je uspješno upisan u naredni semestar.');
                this.setState({ enrollStep2Loader: false });
                this.fetchSemesters();

                this.setState({
                    studyType: '', studentStatus: '', currentSemester: '', open: false, typeOfEnrollment: null
                });
            })
            .catch(err => {
                if (err.response.data === 'Student cannot be enrolled in next semester if course implementations are not created!') {
                    toast('Nije moguć upis u semestar. Implementacije predmeta nisu kreirane.');
                } else if (err.response.data === 'Student does not have internship for previous academic year and thus cannot be enrolled in semester for current academic year!') {
                    toast('Student ne može biti upisan u naredni semestar, jer nema unesene podatke o ferijalnoj praksi za prethodnu akademsku godinu.');
                } else { toast('Došlo je do greške! Student nije upisan u naredni semestar.'); }
                this.setState({ open: false, enrollStep2Loader: false });
            });
    }

    enroll() {
        let obj = {
            studentStudyProgramId: this.props.studentStudyProgramId,
            studyType: { id: this.state.studyType.id },
            studentStatus: { id: this.state.studentStatus.id, _key: this.state.studentStatus._key },
            semester: this.state.semester,
            studyProgramSemester: { id: this.state.studyProgramSemester.id },
            unconditionalEnrollment: false,
            ectsTransferWithinStudyCycle: false
        };
        axios.post('/semester-enrollment/next-semester/by-admin', { ...obj })
            .then(res => {
                toast('Student je uspješno upisan u naredni semestar.');
                this.fetchSemesters();
            })
            .catch(err => {
                if (err.response.data === 'Student was already enrolled in this semester!') {
                    toast('Došlo je do greške! Student je već upisan u ovaj semestar.');
                }
                toast('Došlo je do greške! Student nije upisan u naredni semestar.');
            });
    }

    getCoursesForSemester(id, spId, aps) {
        this.setState({ loadingCourses: true });
        let obj = {};
        if (aps === 'apsolvent') {
            obj = {
                semester: {
                    academicYear: {
                        id: this.props.gradStudentAcademicYear
                    }
                },
                studentStudyProgram: { id: this.props.studentStudyProgramId }
            };
        } else {
            obj = {
                semester: { id },
                studentStudyProgram: { id: spId }
            };
        }
        axios.post('students/courses-by-semester', { ...obj })
            .then(res => {
                this.setState({ courses: res.data, loadingCourses: false });
            })
            .catch(err => {
                console.log('Failed to fetch courses for semester.');
            });
    }

    studentGradEnroll() {
        if (!this.state.studyTypeGrad || !this.state.studentStatusGrad) {
            toast('Morate unijeti obavezna polja');
            if (!this.state.studyTypeGrad) { this.setState({ studyTypeGradErr: true }); } else { this.setState({ studyTypeGradErr: false }); }
            if (!this.state.studentStatusGrad) { this.setState({ studentStatusGradErr: true }); } else { this.setState({ studentStatusGradErr: false }); }
        } else {
            axios.get(`students/study-program/${this.props.studentStudyProgramId}/`)
                .then(res => {
                    let obj = {
                        id: this.props.studentStudyProgramId,
                        optLock: res.data.optLock,
                        gradAcademicYearStudyTypeId: this.state.studyTypeGrad.id,
                        gradAcademicYearStudentStatusId: this.state.studentStatusGrad.id,
                    };
                    axios.put('students/enroll/grad-year/', { ...obj })
                        .then(ress => {
                            toast('Student je uspješno upisan u apsolventski staž.');
                            this.closeAndResetForm();
                            this.isGradStudent();
                        })
                        .catch(err => {
                            if (err.response.data === 'Student is already enrolled in this academic year!') {
                                toast('Student je već upisan u trenutnu akademsku godinu!');
                            } else if (err.response.data === 'Student is already enrolled as grad!') {
                                toast('Student je već upisan u apsolventski staž!');
                            } else {
                                toast('Došlo je do greške! Student nije upisan u apsolventski staž.');
                            }
                            // this.closeAndResetForm();
                        });
                })
                .catch(err => {
                    console.log('Failed to fetch student study program optLock');
                });
        }
    }

    processNextEnrollment(studentStudyProgramId, typeOfEnrollment) {
        this.setState({ enrollStep1Loader: true });
        const semester = { id: this.state.currentSemester };
        axios.all([fetchStudentSemesterInfo(studentStudyProgramId, typeOfEnrollment, semester), fetchCourses(studentStudyProgramId)])
            .then(axios.spread((infoRes, coursesRes) => {
                this.setState({
                    semesterToEnroll: infoRes.data.semesterToEnroll !== null ? infoRes.data.semesterToEnroll.name : '',
                    requiredEcts: infoRes.data.requiredEcts !== null ? infoRes.data.requiredEcts : '',
                    acquiredEcts: infoRes.data.acquiredEcts !== null ? infoRes.data.acquiredEcts : '',
                    courses: coursesRes.data ? coursesRes.data : [],
                    locked: infoRes.data.locked,
                    graduated: infoRes.data.graduated
                });
            })).then(() => {
                this.setState({ open: true, enrollStep1Loader: false, showCourses: false });
            }).catch(err => {
                this.setState({ enrollStep1Loader: false });
                if (err.response.data === 'Student is already enrolled in selected semester!') {
                    toast('Student je već upisan u odabrani semestar u trenutnoj akademskoj godini!');
                } else if (err.response.data === 'Student is already enrolled as grad!') {
                    toast('Student je upisan u apsolventski staž u trenutnoj akademskoj godini!');
                } else {
                    toast('Došlo je do greške!');
                }
            });
    }


    closeAndResetForm() {
        this.setState({ gradEnroll: false, studyTypeGrad: null, studentStatusGrad: null });
    }

    render() {
        const {
            open, currentSemestersDropdown, currentSemester, studentStatus, studentStatuses, studyType,
            studyTypes, acquiredEcts, semesterToEnroll, courses, typeOfEnrollment, studentStatusGrad, studyTypeGrad,
            studyTypeGradErr, studentStatusGradErr, gradStudentAcademicYearId
        } = this.state;
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div >
                <Modal
                    open={open}
                    onClose={() => this.setState({ open: false })}
                    center
                ><br />
                    <h2>Upis studenta u naredni semestar</h2>
                    <Divider />
                    <Segment color="blue" clearing>
                        <Table celled unstackable compact>
                            <Table.Header>
                                <Table.Row>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                <SimpleTwoColumnTableRow
                                    name="Broj ECTS bodova"
                                    keyName="acquiredEcts"
                                    value={acquiredEcts}
                                />
                                {/* <SimpleTwoColumnTableRow */}
                                {/* name='Broj potrebnih ECTS bodova' */}
                                {/* keyName="requiredEcts" */}
                                {/* value={requiredEcts} */}
                                {/* disabled */}
                                {/* /> */}
                                <SimpleTwoColumnTableRow
                                    name="Semestar u koji se student upisuje"
                                    keyName="semesterToEnroll"
                                    value={semesterToEnroll}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Akademski semestar"
                                    keyName="currentSemester"
                                    value={currentSemester ? currentSemestersDropdown.find(el => el.value === currentSemester).text : ''}
                                />

                                <SimpleTwoColumnTableRow
                                    name="Status studenta"
                                    keyName="studentStatus"
                                    value={studentStatus ? studentStatuses.find(el => el.value === studentStatus).text : ''}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Tip studiranja"
                                    keyName="studyType"
                                    value={studyType ? studyTypes.find(el => el.value === studyType).text : ''}
                                />
                                <SimpleTwoColumnTableRow
                                    name="Predmeti koje student prenosi"
                                    keyName="courses"
                                    value={courses.map(el => (<div><strong>{el.courseName}</strong>&nbsp;({el.semester}) </div>))}
                                />
                            </Table.Body>
                        </Table>


                        <Button floated="right" color="blue" basic="true" disabled={this.state.enrollStep2Loader} onClick={() => this.setState({ open: false })}>Odustani</Button>
                        <Button floated="right" color="blue" loading={this.state.enrollStep2Loader} onClick={this.enrollStudent}>Upiši studenta</Button>

                    </Segment>
                </Modal>

                {(localStorage.getItem('activeRole').substr(0, 13) === 'Administrator' || localStorage.getItem('activeRole') === 'AIDA') && <div>

                    <Radio
                        toggle
                        label="Naknadni upis u semestar (bez upisa na predmete)"
                        name="currentEnrollment"
                        checked={this.state.currentEnrollment === true}
                        onChange={() => this.setState({ currentEnrollment: !this.state.currentEnrollment })}
                    />


                    {this.state.currentEnrollment && <Segment secondary>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <Form.Dropdown
                                        label="Akademska godina"
                                        placeholder="Odaberite akademsku godinu"
                                        value={this.state.academicYearId}
                                        onChange={this.handleInputChange}
                                        name="academicYearId"
                                        options={this.state.academicYearsAdmin}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <Form.Dropdown
                                        label="Semestar"
                                        disabled={!this.state.academicYearId}
                                        placeholder="Odaberite semestar"
                                        options={this.state.semesters}
                                        onChange={this.handleInputChange}
                                        name="semester"
                                        value={this.state.semester}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <Form.Dropdown
                                        label="Broj semestra"
                                        clearable
                                        placeholder="Odaberite smemestar"
                                        options={this.state.studyProgramSemesters}
                                        onChange={this.handleInputChange}
                                        name="studyProgramSemester"
                                        value={this.state.studyProgramSemester}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field required>
                                    <label>Tip studiranja studenta</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odabir tipa"
                                        value={studyType}
                                        onChange={this.handleInputChange}
                                        name="studyType"
                                        options={studyTypes}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field required>
                                    <label>Status studenta</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odabir statusa"
                                        value={studentStatus}
                                        onChange={this.handleInputChange}
                                        name="studentStatus"
                                        options={studentStatuses}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>

                            </Form.Group>
                            <Button
                                floated="right"
                                color="blue"
                                onClick={this.enroll}
                            >Upis u semestar</Button>
                            <br />
                            <br />
                        </Form>
                    </Segment>}</div>}
                {(((!this.props.thirdCycle && !this.state.locked && !this.state.graduated && !this.props.limitation && !this.state.gradEnroll) && localStorage.getItem('activeRole') !== 'AIDA'
                            && localStorage.getItem('activeRole') !== 'Support' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu' && localStorage.getItem('activeRole').substr(0, 13) !== 'Administrator')
                        || ((localStorage.getItem('activeRole').substr(0, 13) === 'Administrator' || localStorage.getItem('activeRole') === 'AIDA') && this.state.currentEnrollment === false)) &&
                        <Segment secondary>
                            <Form>
                                <Form.Group widths="equal">
                                    <Form.Field required>
                                        <label>Semestar u koji upisujete studenta</label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder="Odabir semestra"
                                            value={currentSemester}
                                            onChange={this.handleInputChange}
                                            name="currentSemester"
                                            options={currentSemestersDropdown}
                                            search
                                            fluid
                                            selection
                                        />
                                    </Form.Field>
                                    <Form.Field required>
                                        <label>Tip studiranja studenta</label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder="Odabir tipa"
                                            value={studyType}
                                            onChange={this.handleInputChange}
                                            name="studyType"
                                            options={studyTypes}
                                            search
                                            fluid
                                            selection
                                        />
                                    </Form.Field>
                                    <Form.Field required>
                                        <label>Status studenta</label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder="Odabir statusa"
                                            value={studentStatus}
                                            onChange={this.handleInputChange}
                                            name="studentStatus"
                                            options={studentStatuses}
                                            search
                                            fluid
                                            selection
                                        />
                                    </Form.Field>
                                    <Form.Field>
                                        <label>Uslovi upisa</label>
                                        <Form.Dropdown
                                            clearable
                                            placeholder="Odabir uslova"
                                            value={typeOfEnrollment}
                                            onChange={this.handleInputChange}
                                            name="typeOfEnrollment"
                                            options={typeOfEnrollmentOptions}
                                            search
                                            fluid
                                            selection
                                        />
                                    </Form.Field>

                                </Form.Group>
                                <Button
                                    floated="right"
                                    color="blue"
                                    loading={this.state.enrollStep1Loader}
                                    onClick={() => {
                                        if (currentSemester && studentStatus && studyType) {
                                            const { studentStudyProgramId } = this.props;
                                            this.processNextEnrollment(studentStudyProgramId, this.state.typeOfEnrollment);
                                        } else toast('Niste unijeli sva obavezna polja!');
                                    }}
                                >Upis u semestar</Button>
                                <br />
                                <br />
                            </Form>
                        </Segment>}

                {(!gradStudentAcademicYearId) && (!this.state.gradEnroll && !this.props.limitation && localStorage.getItem('thirdCycle') !== '1' &&
                    localStorage.getItem('activeRole') !== 'AIDA' && localStorage.getItem('activeRole') !== 'Support' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu') && <div> <br />
                    <br /><Button
                        floated="right"
                        color="blue"
                        basic="true"
                        onClick={() => { this.setState({ gradEnroll: true }); }}
                        >Upis u apsolventski staž
                        </Button></div>}
                {this.state.gradEnroll && <div>
                    <Segment secondary>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field required error={studyTypeGradErr}>
                                    <label>Tip studiranja studenta</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odabir tipa"
                                        value={studyTypeGrad}
                                        onChange={this.handleInputChange}
                                        name="studyTypeGrad"
                                        options={studyTypes}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field required error={studentStatusGradErr}>
                                    <label>Status studenta</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odabir statusa"
                                        value={studentStatusGrad}
                                        onChange={this.handleInputChange}
                                        name="studentStatusGrad"
                                        options={studentStatuses}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>

                            </Form.Group>
                            <Button
                                floated="right"
                                color="red"
                                basic="true"
                                onClick={this.closeAndResetForm}
                            >Odustani</Button>
                            <Button
                                floated="right"
                                color="blue"
                                basic
                                onClick={this.studentGradEnroll}
                            >Upiši u apsolventski staž</Button>

                            <br />
                            <br />
                        </Form>
                    </Segment>
                    <br />
                </div>}
                {this.state.showCourses && <div><br /><br /><br /><br />
                    <Button
                        circular
                        icon="close"
                        size="small"
                        iverted
                        basic="true"
                        floated="right"
                        onClick={() => this.setState({ showCourses: false, courses: [] })}
                    />
                    <h3>Spisak predmeta za {this.state.coursesForSemester}. akademske godine</h3>
                    {this.state.courses.length ? <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width="1">R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan="2">Predmet</Table.HeaderCell>
                                {/* {localStorage.getItem('apsolvent') && <Table.HeaderCell>Semestar</Table.HeaderCell>} */}
                                <Table.HeaderCell width="2" >Šifra</Table.HeaderCell>
                                <Table.HeaderCell width="1">ECTS</Table.HeaderCell>
                                <Table.HeaderCell width="2" >P + V + S + T</Table.HeaderCell>
                                <Table.HeaderCell width="2" >Tip predmeta</Table.HeaderCell>
                                <Table.HeaderCell width="2" />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body> {this.state.courses.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle">
                                    {index + 1}.
                                </Table.Cell>
                                <Popup
                                    content={el.semesterNameKey === 'winter semester' ? 'Implementacija predmeta u zimskom semestru' : 'Implementacija predmeta u ljetnom semestru'}
                                    hideOnScroll
                                    position="left center"
                                    trigger={<Table.Cell colSpan="2" verticalAlign="middle">
                                        <Grid columns={1} centered className="stackable">
                                            <Grid.Column width="10">
                                                <span >  { el.semesterNameKey === 'winter semester' ? <Icon name="snowflake" color="blue" /> : <Icon name="sun" color="yellow" />}{el.courseBasicName}</span>
                                            </Grid.Column>
                                            <Grid.Column width="6" verticalAlign="middle" textAlign="right">

                                                <span style={{ color: '#a6a4a1' }}>

                                                    {el.courseBasicComment && <Label as="a" basic><Icon name="comment alternate outline" />{el.courseBasicComment}</Label>}
                                                    {el.collision && <Label as="a" basic><Icon name="random" />Kolizija</Label>}

                                                </span>
                                            </Grid.Column>
                                        </Grid>

                                    </Table.Cell>}
                                />

                                {/* {localStorage.getItem('apsolvent') && <Table.Cell verticalAlign="middle"> */}
                                {/*    {el.semester} */}
                                {/* </Table.Cell>} */}
                                <Table.Cell verticalAlign="middle">
                                    {el.code}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.ects}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.lectureNumber ? el.lectureNumber : '0'} + {el.exerciseNumber ? el.exerciseNumber : '0'} + {el.seminarNumber !== null ? el.seminarNumber : '0'} + {el.tutorialNumber ? el.tutorialNumber : '0'}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.mandatory ? 'Obavezni' : 'Izborni'}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" textAlign="center">
                                    <Popup
                                        content="Ispiši"
                                        position="top center"
                                        trigger={
                                            <Button
                                                disabled={this.props.limitation || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                                basic="true"
                                                circular
                                                size="small"
                                                color="red"
                                                icon="sign-out"
                                                onClick={() => this.deleteCourse(el)}
                                            />}
                                    />
                                </Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                        : this.state.loadingCourses ? <div style={{ paddingTop: '20px', paddingBottom: '20px' }}><Loader active inline="centered" /> </div> : <p>Nema predmeta.</p>}
                    { !this.props.thirdCycle && <br /> &&
                        <br />}
                </div>}
                {!this.props.limitation && <h3>Prethodni semestri studenta/ice</h3>}
                {studentStatuses.length ? <Table celled selectable compact >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={2}>Semestar (akademska godina)</Table.HeaderCell>
                            <Table.HeaderCell>Broj semestra</Table.HeaderCell>
                            <Table.HeaderCell>Tip studiranja</Table.HeaderCell>
                            <Table.HeaderCell>Status studenta</Table.HeaderCell>
                            <Table.HeaderCell />
                        </Table.Row>
                    </Table.Header>
                    <Table.Body> {this.state.studentSemesters.sort((a, b) => b.semester.academicYear.id - a.semester.academicYear.id).filter(e => e.semester.name.name !== 'ostalo' && e.studyProgramSemester.name !== 'ostalo').map((el, index) =>
                        (<Table.Row key={index}>
                            <Table.Cell verticalAlign="middle" colSpan={2}>
                                {el.semester.name.name} ({el.semester.academicYear.name})
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                {el.studyProgramSemester.name}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                {this.state.edit && this.state.currentSemesterId === el.studentStudyProgramSemesterId ? <Form>
                                    <Form.Field>
                                        <Form.Dropdown
                                            selection
                                            options={this.state.studyTypes}
                                            onChange={this.handleInputChange}
                                            value={this.state.studyTypeEdit ? this.state.studyTypeEdit : el.studyType.id ? studyTypes.find(e => e.id === el.studyType.id).value : ''}
                                            name="studyTypeEdit"
                                            placeholder="Odaberite tip"
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                </Form> : el.studyType && el.studyType.id ? studyTypes.find(e => e.id === el.studyType.id).text : ''}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                {this.state.edit && this.state.currentSemesterId === el.studentStudyProgramSemesterId && el.studentStatus._key !== 'grad_again' && el.studentStatus._key !== 'gap_year' ? <Form>
                                    <Form.Field>
                                        <Form.Dropdown
                                            selection
                                            options={this.state.studentStatusesOpt.filter((e) => (e.value._key !== 'grad_again' && e.value._key !== 'gap_year'))}
                                            onChange={this.handleInputChange}
                                            value={this.state.studentStatusEdit ? this.state.studentStatusEdit : el.studentStatus.id ? this.state.studentStatusesOpt.find(e => e.key === el.studentStatus.id).value : ''}
                                            name="studentStatusEdit"
                                            placeholder="Odaberite status"
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                </Form> : el.studentStatus && el.studentStatus.id ? this.state.studentStatusesLookup.find(e => e.id === el.studentStatus.id).text : ''}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" textAlign="center">
                                {this.state.edit && this.state.currentSemesterId === el.studentStudyProgramSemesterId ?
                                    <Fragment>
                                        <Popup
                                            content="Sačuvaj"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    size="small"
                                                    color="blue"
                                                    icon="check"
                                                    onClick={() => {
                                                        this.setState({ edit: false, currentSemesterId: -1 });
                                                        if (el.semester.name.name === 'Apsolventski staž') {
                                                            this.editStudentStatusAndType(el, true);
                                                        } else {
                                                            this.editStudentStatusAndType(el);
                                                        }
                                                    }}
                                                />}
                                        />
                                        <Popup
                                            content="Odustani"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    size="small"
                                                    color="red"
                                                    icon="close"
                                                    onClick={() => { this.setState({ edit: false, currentSemesterId: -1 }); }}
                                                />}
                                        />
                                    </Fragment>

                                    :
                                    <Fragment>
                                        <Popup
                                            content="Predmeti"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    circular
                                                    size="small"
                                                    color="blue"
                                                    icon="list"
                                                    onClick={() => {
                                                        this.setState({
                                                            currentSemesterId: el.semester.id,
                                                            currentStudentStudyProgramId: el.studentStudyProgramId,
                                                            apsolvent: el.semester.name.name === 'Apsolventski staž',
                                                            courses: [],
                                                            showCourses: true,
                                                            coursesForSemester: el.semester.name.name === 'Apsolventski staž'
                                                                ? 'apsolventski staž ' + el.semester.academicYear.name : el.studyProgramSemester.name + ' semestar  ' + el.semester.academicYear.name
                                                        });

                                                        { el.semester.name.name === 'Apsolventski staž' ? this.getCoursesForSemester(el.semester.id, el.studentStudyProgramId, 'apsolvent')
                                                            : this.getCoursesForSemester(el.semester.id, el.studentStudyProgramId); }
                                                    }
                                                    }
                                                />}
                                        />
                                        <Popup
                                            content="Izmjena"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    disabled={localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || this.props.limitation}
                                                    basic="true"
                                                    circular
                                                    size="small"
                                                    color="green"
                                                    icon="pencil"
                                                    onClick={() => {
                                                        this.setState({ edit: true, currentSemesterId: el.studentStudyProgramSemesterId });
                                                    }}
                                                />}
                                        />
                                        <Popup
                                            content="Ispiši"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    disabled={localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || this.props.limitation}
                                                    basic="true"
                                                    circular
                                                    size="small"
                                                    color="red"
                                                    icon="sign-out"
                                                    onClick={() => el.semester.name.name === 'Apsolventski staž' ? this.deleteGradYear(el) : this.deleteSemester(el)}
                                                />}
                                        />
                                    </Fragment>

                                }

                            </Table.Cell>
                        </Table.Row>))}
                    </Table.Body>
                </Table>
                    : <p>Nema podataka o semestrima.</p>}
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/NextSemesterEnroll.js